"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
require("../styles/DispatcherStoreDashboard.css");
var _HomeDispatcherStoreComponent = _interopRequireDefault(require("./HomeDispatcherStoreComponent"));
var _StoreDashBoardFirstVisitComponent = _interopRequireDefault(require("./StoreDashBoardFirstVisitComponent"));
var _reactBootstrap = require("react-bootstrap");
const DispatcherStoreDashboardComponent = _ref => {
  let {
    stores,
    isLoading,
    handleClick,
    subHeading,
    heading,
    headerText,
    separator,
    loginType,
    string,
    successLabel,
    title,
    rightText,
    isDisableIcon,
    isDisableText,
    onScrollHandler,
    everythingOkIcon
  } = _ref;
  const getBodyDiv = () => {
    return rightText === 0 ? /*#__PURE__*/_react.default.createElement(_StoreDashBoardFirstVisitComponent.default, {
      headerText: headerText,
      string: string
    }) : /*#__PURE__*/_react.default.createElement(_HomeDispatcherStoreComponent.default, {
      handleClick: handleClick,
      stores: stores,
      loginType: loginType,
      successLabel: successLabel,
      title: title,
      rightText: rightText,
      isDisableIcon: isDisableIcon,
      isDisableText: isDisableText,
      onScrollHandler: onScrollHandler,
      everythingOkIcon: everythingOkIcon
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dispatcherStore-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: heading,
    subHeading: subHeading,
    separator: separator
  }), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper",
    style: {
      zIndex: 9999
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : getBodyDiv());
};
var _default = exports.default = DispatcherStoreDashboardComponent;